export const GET_ACCOUNTS_SUCCESS = 'accounts/GET_ACCOUNTS_SUCCESS';
export const GET_REVIEW_ACCOUNTS_SUCCESS = 'accounts/GET_REVIEW_ACCOUNTS_SUCCESS';
export const GET_ACCOUNT_SUCCESS = 'accounts/GET_ACCOUNT_SUCCESS';
export const UPDATE_ACCOUNT_SUCCESS = 'accounts/UPDATE_ACCOUNT_SUCCESS';
export const SAVE_PRICING_INPUT = 'accounts/SAVE_PRICING_INPUT';
export const GET_PLAN_SUCCESS = 'accounts/GET_PLAN_SUCCESS';
export const UPDATE_PLAN_CLASS_RECORD = 'accounts/UPDATE_PLAN_CLASS_RECORD';
export const CREATE_NEW_PLAN_DESIGN = 'accounts/CREATE_NEW_PLAN_DESIGN';
export const REVERT_TO_PLAN_DESIGN_REVISION = 'accounts/REVERT_TO_PLAN_DESIGN_REVISION';

export const ADD_CENSUS_USER_SUCCESS = 'accounts/ADD_CENSUS_USER_SUCCESS';
export const REMOVE_CENSUS_USER_SUCCESS = 'accounts/REMOVE_CENSUS_USER_SUCCESS';
export const ADD_CLASS_SUCCESS = 'accounts/ADD_CLASS_SUCCESS';
export const ADD_DESIGN_FOR_NEW_CLASS = 'accounts/ADD_DESIGN_FOR_NEW_CLASS';
export const EDIT_CLASS_SUCCESS = 'accounts/EDIT_CLASS_SUCCESS';
export const ADD_DIVISION_SUCCESS = 'accounts/ADD_DIVISION_SUCCESS';
export const EDIT_DIVISION_SUCCESS = 'accounts/EDIT_DIVISION_SUCCESS';
export const UPDATE_CENSUS_USER_SUCCESS = 'accounts/UPDATE_CENSUS_USER_SUCCESS';
export const GET_USERS_SUCCESS = 'accounts/GET_USERS_SUCCESS';
export const GET_CENSUS_SUCCESS = 'accounts/GET_CENSUS_SUCCESS';

export const CREATE_ADMIN_SUCCESS = 'accounts/CREATE_ADMIN_SUCCESS';
export const UPDATE_ADMIN_SUCCESS = 'accounts/UPDATE_ADMIN_SUCCESS';
export const REMOVE_ADMIN_SUCCESS = 'accounts/REMOVE_ADMIN_SUCCESS';

export const UPDATE_CURRENT_ACCOUNT_META = 'accounts/UPDATE_CURRENT_ACCOUNT_META';
export const REMOVE_NOTIFICATION_SUCCESS = 'accounts/REMOVE_NOTIFICATION_SUCCESS';

export const SAVE_TELUS_DRUG_PLAN_ID = 'accounts/SAVE_TELUS_DRUG_PLAN_ID';
export const SAVE_PLAN_DESIGN_BENEFIT_INIT_DATA = 'accounts/SAVE_PLAN_DESIGN_BENEFIT_INIT_DATA';
export const SAVE_PLAN_DESIGN_FIELD = 'accounts/SAVE_PLAN_DESIGN_FIELD';

export const SET_STATE = 'accounts/SET_STATE';

export const SAVE_MODULAR_BENEFIT_INIT_DATA = 'accounts/SAVE_MODULAR_BENEFIT_INIT_DATA';
export const SAVE_MODULAR_FIELD = 'accounts/SAVE_MODULAR_FIELD';

export const SET_ACCOUNT_LIVE = 'accounts/SET_ACCOUNT_LIVE';

export const GET_REVISION_SUCCESS = 'accounts/GET_REVISION_SUCCESS';

export const SAVE_FULL_PLAN_DESIGN = 'accounts/SAVE_FULL_PLAN_DESIGN';

export const SAVE_COMMISSIONS = 'accounts/SAVE_COMMISSIONS';

export const UPDATE_REVISION_MODULAR_CLASSES = 'accounts/UPDATE_REVISION_MODULAR_CLASSES';